import type { HTMLAttributes } from 'react'
import { InfoIcon } from 'icons'
import styled from 'styled-components'

export default function InfoTooltip({ children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <Wrapper {...props}>
      <InfoIcon />
      <Tooltip>{children}</Tooltip>
    </Wrapper>
  )
}

const Tooltip = styled.span`
  width: max-content;
  max-width: 200px;

  padding: 10px 8px;

  background: var(--white);
  border-radius: 4px;
  filter: drop-shadow(0 0 2px var(--light-gray)) drop-shadow(0 4px 2px rgba(0, 0, 0, 0.25));

  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(0);

  pointer-events: none;
  transition: all 0.2s;
  opacity: 0;

  ::before {
    content: '';
    position: absolute;
    left: -6px;
    top: 50%;
    transform: translateY(-50%);
    border-top: 6px solid transparent;
    border-right: 6px solid var(--white);
    border-bottom: 6px solid transparent;
  }
`

const Wrapper = styled.span`
  display: inline-flex;
  position: relative;

  svg {
    color: var(--green);
    width: 14px;
    height: 14px;
    cursor: help;
  }

  :hover ${Tooltip} {
    opacity: 1;
    transform: translateY(-50%);
    pointer-events: all;
  }
`
